import React from 'react';
import { Box } from '@mui/material';
import Grid from '@mui/material/Grid';
import { FormInput } from 'components/molecules/FormInput';
import { FormDatePicker } from 'components/molecules/FormDatePicker';

interface IAddPreviousAddressListItem {
  index: number;
  arrayName?: string;
  control: any;
  errors: any;
}

const AddPreviousAddressListItem = ({
  index,
  arrayName,
  control,
  errors,
}: IAddPreviousAddressListItem) => (
  <Box>
    <Grid container spacing={1}>
      <Grid item xs={8}>
        <FormInput
          name={`${arrayName}[${index}].previousAddress`}
          label="Previous Address"
          fieldName="previousAddress"
          arrayName={arrayName}
          arrayIndex={index}
          control={control}
          errors={errors}
          InputProps={{ readOnly: true }}
        />
      </Grid>
      <Grid item xs={4}>
        <FormInput
          name={`${arrayName}[${index}].previousPostcode`}
          label="Previous Postcode"
          fieldName="previousPostcode"
          arrayName={arrayName}
          arrayIndex={index}
          control={control}
          errors={errors}
          InputProps={{ readOnly: true }}
        />
      </Grid>
    </Grid>

    <Grid container spacing={1}>
      <Grid item xs={4}>
        <FormInput
          name={`${arrayName}[${index}].prevCity`}
          label="City/Town"
          fieldName="prevCity"
          arrayName={arrayName}
          arrayIndex={index}
          required
          control={control}
          errors={errors}
          InputProps={{ readOnly: true }}
        />
      </Grid>
      <Grid item xs={4}>
        <FormInput
          name={`${arrayName}[${index}].prevState`}
          label="State/Province"
          fieldName="prevState"
          arrayName={arrayName}
          arrayIndex={index}
          required
          control={control}
          errors={errors}
          InputProps={{ readOnly: true }}
        />
      </Grid>
      <Grid item xs={4}>
        <FormInput
          name={`${arrayName}[${index}].prevCountry`}
          label="Country"
          fieldName="prevCountry"
          arrayName={arrayName}
          arrayIndex={index}
          required
          control={control}
          errors={errors}
          InputProps={{ readOnly: true }}
        />
      </Grid>
    </Grid>

    <Grid container spacing={1}>
      <Grid item xs={4}>
        <FormDatePicker
          name={`${arrayName}[${index}].prevFromDate`}
          label="From Date*"
          fieldName="prevFromDate"
          arrayName={arrayName}
          arrayIndex={index}
          openTo="year"
          control={control}
          errors={errors}
        />
      </Grid>
      <Grid item xs={4}>
        <FormDatePicker
          name={`${arrayName}[${index}].prevToDate`}
          label="To Date*"
          fieldName="prevToDate"
          arrayName={arrayName}
          arrayIndex={index}
          openTo="year"
          control={control}
          errors={errors}
        />
      </Grid>
    </Grid>
  </Box>
);

export default AddPreviousAddressListItem;
